// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { costCodesStyles } from "@guestsupply/Overrides/Widgets/Budget/CostCodes";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { css } from "styled-components";

costCodesStyles.titleGridItems = {
    width: [12, 7, 8, 8, 8],
    css: css`
        align-items: center;
        padding: 20px 0 15px;
    `,
};

costCodesStyles.titleText = {
    variant: "h2",
};

costCodesStyles.buttonsGridItem = {
    width: [12, 5, 4, 4, 4],
    css: css`
        justify-content: flex-end;
        padding: 20px 0 15px;
        ${xScreen("lte", "xs")} {
            padding-top: 0;
        }
    `,
};

costCodesStyles.buttonsHidden = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: flex-end;
        ${xScreen("lte", "xs")} {
            padding-top: 15px;
        }
    `,
};

costCodesStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-top: 2px;
        ${xScreen("lte", "xs")} {
            width: 50%;
            margin-top: 0;
        }
    `,
};

costCodesStyles.saveButton = {
    css: css`
        margin-left: 10px;
        margin-top: 2px;
        ${xScreen("lte", "xs")} {
            width: 50%;
            margin-top: 0;
        }
    `,
};

costCodesStyles.costCodeTitleTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            margin-bottom: 3px;
        `,
    },
};

costCodesStyles.gridItems = {
    width: [12, 12, 9, 9, 9],
    css: css`
        padding-bottom: 9px;
        ${xScreen("lte", "xs")} {
            padding-top: 10px;
        }
    `,
};

costCodesStyles.addCostCodeButtonGridItems = {
    width: [12, 6, 6, 6, 6],
    css: css`
        padding: 22px 0 15px;
        ${xScreen("lte", "xs")} {
            padding: 15px 0;
        }
    `,
};

costCodesStyles.addCostCodeButton = {
    variant: "secondary",
    css: css`
        display: block;
        ${xScreen("lte", "xs")} {
            width: calc(50% - 5px);
        }
    `,
};

costCodesStyles.gridContainer = {
    gap: 0,
};

costCodesStyles.costCodeTitleGridItems = {
    width: [12, 12, 6, 6, 4],
    css: css`
        display: block;
        padding: 10px 0 15px;
        ${FormInputWrapper} {
            max-width: 450px;
        }
    `,
};

costCodesStyles.wrapper = {
    css: css`
        width: 100%;
        padding: 15px 0 8px;
        ${xScreen("lte", "xs")} {
            padding: 15px 0;
        }
    `,
};

costCodesStyles.costCodesTableGridItems = {
    width: [12, 12, 12, 6, 6],
};
